export const vocabularyCardContent = {
    warning: {
        en: "Attention! This is cursing!",
        es: "¡Atención! ¡Esto es una maldición!"
    }
}